function mobileMenu() {
  let el = document.querySelectorAll('.menu-toggle');
  for (var i = 0; i < el.length; i++) {
    el[i].addEventListener('click', function () {
      document.querySelector('.main-navigation').classList.toggle('active');
      document.querySelector('.menu-open').classList.toggle('active');
      document.querySelector('.menu-bg').classList.toggle('active');
    });
  }
}
mobileMenu();

//close mobile menu after click to li url
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const element = e.target.closest('.main-navigation.active li a');
    if (!element) return;
    document.querySelector('.main-navigation').classList.toggle('active');
    document.querySelector('.menu-open').classList.toggle('active');
    document.querySelector('.menu-bg').classList.toggle('active');
  });
});

//review slider
document.addEventListener('DOMContentLoaded', () => {
  const isRTL = document.documentElement.dir === 'rtl' || document.body.dir === 'rtl';

  let productGallery = document.getElementsByClassName('review-slider');
  if (!productGallery) return false;

  Array.prototype.filter.call(productGallery, heroCarousel => {
    let carousel = new Glide(heroCarousel, {
      type: 'carousel',
      direction: isRTL ? 'rtl' : 'ltr',
      animationDuration: 800,
      autoplay: 5000,
      focusAt: '0',
      perView: 4,
      gap: 20,
      peek: {
        before: 0,
        after: 100,
      },
      breakpoints: {
        1600: {
          perView: 3,
          peek: { before: 0, after: 400 },
        },
        1260: {
          perView: 3,
          peek: { before: 0, after: 100 },
        },
        991: {
          perView: 2,
          peek: { before: 0, after: 200 },
        },
        767: {
          perView: 1,
          peek: { before: 0, after: 240 },
        },
        575: {
          perView: 1,
          peek: { before: 0, after: 100 },
        }
      },
    });

    carousel.on('mount.before', function() {
      var directionModule = carousel._c.Direction;
      var origResolve = directionModule && directionModule.resolve;
      if (origResolve && isRTL) {
        carousel._c.Direction.resolve = function(pattern) {
          var token = pattern.slice(0, 1);
          if (token === '|') {
            var dir = pattern.slice(1);
            var flip = {'>': '<', '<': '>'};
            return '|' + (flip[dir] || dir);
          }
          var flip = {'>': '<', '<': '>', '=': '='};
          return this.is('rtl')
            ? pattern.split(token).join(flip[token] || token)
            : pattern;
        };
      }
    });

    carousel.mount();
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const lazyBackgrounds = document.querySelectorAll(".lazy-background");
  const lazyImages = document.querySelectorAll(".lazy-image");

  const loadBackground = (element) => {
    let bgImage = element.getAttribute("data-bg");
    if (bgImage) {
      // Перевірка для мобільного вигляду
      if (window.matchMedia("(max-width: 767px)").matches && element.getAttribute("data-bg-mobile")) {
        bgImage = element.getAttribute("data-bg-mobile");
      }

      element.style.backgroundImage = `url(${bgImage})`;
      element.classList.add("loaded");
    }
  };

  const lazyLoad = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;

        // Lazy load background images
        if (element.classList.contains("lazy-background")) {
          loadBackground(element);
        }

        // Lazy load standard images
        if (element.classList.contains("lazy-image")) {
          const imgSrc = element.getAttribute("data-src");
          if (imgSrc) {
            element.src = imgSrc;
            element.onload = () => element.classList.add("loaded");
            element.removeAttribute("data-src"); // Cleanup after loading
          }
        }

        observer.unobserve(element); // Stop observing once loaded
      }
    });
  };

  const observer = new IntersectionObserver(lazyLoad, {
    root: null,
    rootMargin: "0px",
    threshold: 0.1
  });

  // Observe lazy background elements
  lazyBackgrounds.forEach(background => observer.observe(background));

  // Observe lazy image elements
  lazyImages.forEach(image => observer.observe(image));

  // Перевірка бекграунду при зміні розміру вікна
  window.addEventListener("resize", () => {
    lazyBackgrounds.forEach(background => {
      if (!background.classList.contains("loaded")) {
        loadBackground(background);
      }
    });
  });
});


//FAQ
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.faq-item');

  items.forEach(item => {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');

    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      // закриваємо всі
      items.forEach(i => {
        i.classList.remove('active');
        i.querySelector('.faq-answer').style.maxHeight = null;
      });

      // відкриваємо поточний
      if (!isOpen) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
});


//program
document.addEventListener('DOMContentLoaded', () => {
  const items2 = document.querySelectorAll('.wrap-etap');

  items2.forEach(item => {
    const question2 = item.querySelector('.num');
    console.log(question2);
    const answer2 = item.querySelector('.etap');

    question2.addEventListener('click', () => {
      const isOpen2 = item.classList.contains('active');

      // закриваємо всі
      // items2.forEach(i => {
      //   i.classList.remove('active');
      //   i.querySelector('.etap').style.maxHeight = null;
      // });

      // відкриваємо поточний
      if (!isOpen2) {
        item.classList.add('active');
        answer2.style.maxHeight = answer2.scrollHeight + 'px';
      } else {
        item.classList.remove('active');
        item.querySelector('.etap').style.maxHeight = null;
      }
    });
  });
});


//timeline
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.timeline-item');
  const timeline = document.querySelector('.timeline');

  // Перевірка що обидва елементи існують
  if (!items.length || !timeline) return;

  function checkActive() {
    const middle = window.innerHeight / 2;

    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      if (rect.top < middle && rect.bottom > middle) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    const scrollTop = window.scrollY;
    const timelineTop = timeline.offsetTop;
    const timelineHeight = timeline.offsetHeight;
    const windowHeight = window.innerHeight;

    let progress = ((scrollTop + windowHeight / 2 - timelineTop) / timelineHeight) * 100;
    progress = Math.min(Math.max(progress, 0), 100);

    timeline.style.setProperty('--progress-height', progress + '%');
  }

  window.addEventListener('scroll', checkActive);
  checkActive();
});

//lang
document.addEventListener('DOMContentLoaded', () => {
  const langWraps = document.querySelectorAll('.lang-wrap');

  if (!langWraps.length) return;

  langWraps.forEach(lang => {
      lang.addEventListener('click', (e) => {
          e.stopPropagation();
          // Закриваємо всі інші перед відкриттям поточного
          langWraps.forEach(other => {
              if (other !== lang) other.classList.remove('show');
          });
          lang.classList.toggle('show');
      });
  });

  // Клік за межами — закриває всі
  document.addEventListener('click', () => {
      langWraps.forEach(lang => lang.classList.remove('show'));
  });
});